import { useCurrentOverlay } from "shared/context/overlay/OverlayIDContext"
import { useEvent } from "shared/lib/useEvent"

import { useDeleteProjectChildren } from "entities/project-children/api/useDeleteProjectChildren"
import { useDeleteRoom } from "entities/rooms/api/useDeleteRoom"

import { DeleteRoomOverlayModel } from "../DeleteRoomOverlay"
import { DeleteRoomOverlayPayload } from "../DeleteRoomOverlayConnector"

interface DeleteRoomOverlayModelArgs {
  payload: DeleteRoomOverlayPayload
}

export const useDeleteRoomOverlayModel = ({
  payload
}: DeleteRoomOverlayModelArgs): DeleteRoomOverlayModel => {
  const { closeOverlay } = useCurrentOverlay()
  const { projectID, roomsToDelete } = payload
  const [deleteRoom] = useDeleteRoom()
  const deleteProjectChildren = useDeleteProjectChildren()

  const handleDelete = useEvent(() => {
    closeOverlay()

    if (roomsToDelete.length === 1) {
      return deleteRoom({ id: roomsToDelete[0].id }, projectID)
    }

    return deleteProjectChildren({
      projectID,
      childrenToDelete: roomsToDelete
    })
  })

  return {
    payload,
    confirm: handleDelete,
    closeOverlay
  }
}
